// Journey API prefill (k-ID SOW VT-KID-2026-005). The publisher uploads
// some of a route's images through the journey API, then sends the user
// the hosted link. get_session reports them on settings:
//   supplied_images     subset of ["front", "back", "selfie"]; null when
//                       the journey was not created in API mode
//   journey_mode        "hosted" (prefill) or "headless" (no hosted flow)
//   images_received_at  set once the publisher confirms the upload
// Capture steps skip what was supplied: a supplied front means the
// document phase is done (the back is optional on every API route), a
// supplied selfie means the face phase is done. Sessions without these
// fields get an empty list everywhere, so they behave exactly as before.

const IMAGE_NAMES = ["front", "back", "selfie"];

export function suppliedImages(settings) {
  const raw = settings?.supplied_images;
  if (!Array.isArray(raw) || raw.length === 0) return [];
  // get-session refuses to open a headless journey. If one ever got
  // through, skipping capture here would post the queue a second time
  // (journey-images already started it), so it gets no prefill.
  if (settings?.journey_mode === "headless") return [];
  const names = raw.map((value) => String(value).toLowerCase());
  return IMAGE_NAMES.filter((name) => names.includes(name));
}

export function isImageSupplied(settings, image) {
  return suppliedImages(settings).includes(image);
}

// The document phase is satisfied by the publisher's front image.
export function isDocumentSupplied(settings) {
  return isImageSupplied(settings, "front");
}

export function isSelfieSupplied(settings) {
  return isImageSupplied(settings, "selfie");
}

// Images were declared at create_journey but the publisher has not
// confirmed the upload yet: hold the journey on a waiting screen.
export function areSuppliedImagesPending(settings) {
  return suppliedImages(settings).length > 0 && !settings?.images_received_at;
}
